function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import PropTypes from 'prop-types';
import Events from '@render-props/events';
import { throttle } from '@render-props/throttle';
import { getSize, getAspect } from './utils';
import { win } from './statics';
/**
<ViewportSize>
  {
    ({width, height}) => (
      <Row>
        <Col x={8}>viewport width: {width}</Col>
        <Col x={8}>viewport height: {height}</Col>
      </Row>
    )
  }
</ViewportSize>
**/

export var ViewportSize_ =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ViewportSize_, _React$Component);

  function ViewportSize_() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.setSize = throttle(function () {
      return _this.forceUpdate();
    });
    return _this;
  }

  var _proto = ViewportSize_.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.addEvent(win, 'resize', this.setSize);
    this.props.addEvent(win, 'orientationchange', this.setSize);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.setSize.cancel();
  };

  _proto.render = function render() {
    var props;

    if (this.props.withCoords) {
      props = getSize();
      props.aspect = getAspect(win);
    } else {
      props = {
        getAspect: getAspect,
        getSize: getSize
      };
    }

    return this.props.children(props);
  };

  return ViewportSize_;
}(React.Component);
ViewportSize_.displayName = 'ViewportSize';
ViewportSize_.propTypes = {
  children: PropTypes.func.isRequired,
  withCoords: PropTypes.bool
};
ViewportSize_.defaultProps = {
  withCoords: true
};
export default function ViewportSize(props) {
  return React.createElement(Events, null, function (eventsContext) {
    return React.createElement(ViewportSize_, _extends({}, eventsContext, {
      withCoords: props.withCoords,
      children: props.children
    }));
  });
}